"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
class ConnectionAlreadyAcceptedError extends client_library_1.ExtendableError {
    constructor() {
        super('Connection has already been accepted');
    }
}
exports.default = ConnectionAlreadyAcceptedError;
//# sourceMappingURL=ConnectionAlreadyAcceptedError.js.map